import React from 'react';
import { FieldValidation } from '@rjsf/utils';
import { EnvironmentInput } from '../../components/input/EnvironmentInput';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const EnvironmentPicker = ({
  onChange,
  schema: { title, description },
  required,
  rawErrors,
  formData,
  formContext,
}: FieldExtensionComponentProps<string[]>) => {
  return (
    <EnvironmentInput
      label={title}
      helperText={description}
      error={
        rawErrors &&
        rawErrors.length > 0 &&
        (!formData || formData.length === 0)
      }
      required={required}
      product={formContext.formData.product}
      clusterGroup={formContext.formData.clusterGroup}
      namespace={formContext.formData.namespace}
      team={formContext.formData.team}
      onChange={onChange}
      value={formData as string[]}
    />
  );
};

export const validateEnvironmentPickerValidation = (
  value: string[],
  validation: FieldValidation,
) => {
  if (value.length === 0) {
    validation.addError(`At least one environment is mandatory`);
  }
};
